import { useEffect } from "react";
import { useToast } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useStores } from "../../../stores/setup/use-store";

export const useLocationNotifications = () => {
  const {
    dataStores: { locationStore },
  } = useStores();
  const toast = useToast();
  const { t } = useTranslation("translation", {
    keyPrefix: "locations",
  });

  useEffect(() => {
    if (locationStore.messageError) {
      toast({
        title: t("error"),
        description: locationStore.messageError,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  }, [locationStore.messageError]);

  return null;
};
